import SkeletonLoader from "@/components/onboarding/SkeletonLoader";
import {type FC} from "react";

const AmbassadorApplicationSkeleton: FC<{showActions?: boolean}> = ({showActions = true}) => (
  <div className="border-soft-grey-300 flex h-full flex-col items-center justify-between gap-3 rounded-xl border bg-white p-3">
    <div className="flex w-full flex-col gap-2">
      <div className="flex w-full justify-between gap-3">
        <div className="flex items-center gap-2">
          <SkeletonLoader className="size-10 shrink-0 rounded" />
          <div className="flex flex-col gap-1">
            <SkeletonLoader className="h-3 w-24 rounded-md" />
            <SkeletonLoader className="h-5 w-16 rounded-md" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-x-5 gap-y-3">
          {Array.from({length: 4}).map((_, index) => (
            <SkeletonLoader key={`stat-${index}`} className="h-3.5 w-14 rounded-md" />
          ))}
        </div>
      </div>
      <SkeletonLoader className="h-5 w-28 rounded-full" />
      <div className="flex items-center justify-between gap-3">
        <SkeletonLoader className="h-2.5 w-20 rounded-md" />
        <SkeletonLoader className="h-2.5 w-24 rounded-md" />
      </div>
    </div>
    {showActions && (
      <div className="flex w-full gap-3">
        <SkeletonLoader className="size-12 shrink-0 rounded-md" />
        <SkeletonLoader className="h-12 w-full rounded-md" />
      </div>
    )}
  </div>
);

export default AmbassadorApplicationSkeleton;
